<ion-content>
  <div class="widget-container">
    <ion-grid>
      <div class="header-section">
        <ion-label>
          {{ 'Add' | translate }} {{ 'Sales_Organisation' | translate}}
        </ion-label>
        <img class="close-icon" tooltip="{{'Close'  | translate }}" placement="bottom" alt="" (click)="close()" src="assets/icon/cancel.svg">
      </div>
      <ion-searchbar #search 
        debounce="1000" mode='ios' placeholder="{{'SEARCH_SALES_ORGANIZATION' | translate}}" (ionChange)="getSalesOrg($event)"
        [showClearButton]="'always'">
      </ion-searchbar>
      <ion-list class="list-view scrollVertical list-view-wid scroll-searched-container" >
        <ion-item *ngFor="let org of filteredOrgs" lines='none'>
          <ion-checkbox [(ngModel)]="org.selected" (ionChange)="onCheckboxChange(org)"></ion-checkbox>
          <ion-label>{{org.Display_Name }}</ion-label>
        </ion-item>
      </ion-list>
      <div class="org-main scrollVertical" [ngClass]="type==='user_console_add_user' || type==='user_console_group_mang_add_group'? 'selected-org-content' : ''">
        <span *ngFor="let selectedOrg of selectedOrgs">
          <ion-button class="select-org"  (click)='removeOrg(selectedOrg)' shape="round" fill="clear" size="small">
            {{selectedOrg.Display_Name}}&nbsp;&nbsp;<ion-icon  slot="end" name='close-outline'>
            </ion-icon>
          </ion-button>
        </span>
      </div>
      <div class="action-row">
        <ion-button (click)="close()" class="app-btn" shape="round" fill="outline" color="primary">
          {{'Cancel'|translate}}
        </ion-button>
        <ion-button (click)='addSalesOrg()' [disabled]="selectedOrgs.length==0" class="app-btn submit-btn" shape="round" fill="outline" color="primary">
          {{'Submit'|translate}}
        </ion-button>
      </div>
    </ion-grid>
  </div>
</ion-content>